import { IGetOrderListRequest, IGetOrderListResponse, IOrderAuthRequest, IOrderContentResponse } from '@/interfaces/order'
import request from '@/utils/request'
import { AxiosPromise } from 'axios'

const path = '/eco'

export function getOrderList (data: IGetOrderListRequest): AxiosPromise<IGetOrderListResponse> {
  return request({
    url: `${path}/get_order_list.php`,
    method: 'post',
    data
  })
}

export function addBackCart (data: IOrderAuthRequest): AxiosPromise<any> {
  return request({
    url: `${path}/add_back_cart.php`,
    method: 'post',
    data
  })
}

export function getOrderContent (data: IOrderAuthRequest): AxiosPromise<IOrderContentResponse> {
  return request({
    url: `${path}/get_order_content.php`,
    method: 'post',
    data
  })
}
